// side effect: fetch llmf data
import {fetchLLMF} from '../slices/productDataSlice';
import {selectLLMFUrl, selectSpcIsSatisfied, selectSpcSession} from '../selectors';

export const llmfMiddleware = store => next => action => {
    const result = next(action);
	// no single llmf for olivio
	if (store.getState().status.family === 'Olivio') return result;

	if (action.type === 'spc/spcStoreConfiguration') {
		const spcSession = selectSpcSession(store.getState());
		if (spcSession !== null) {
            // after decision(s), get the new llmf file
            if (selectLLMFUrl(store.getState()) !== '-' && selectLLMFUrl(store.getState()) !== null) {
				//console.log('llmfMiddleware', selectLLMFUrl(store.getState()));
                store.dispatch(fetchLLMF({
                    url: selectLLMFUrl(store.getState())
                }));
            }
        }
    }
    return result;
};
